
export const getRegionStyle = () => ({
    color: '#374EBF', // bleu plus clair
    weight: 1,
    opacity: 0.8,
    fillColor: '#1E3A8A', // bleu profond
    fillOpacity: 1
});

export const getHoverStyle = () => ({
    color: '#F59E0B', // or lumineux
    weight: 3,
    opacity: 1,
    fillColor: '#F59E0B', // bleu plus clair
    fillOpacity: 0.9
});
